// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/user_administration.proto (package com.americanexpress.dining.user.admin.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ResyUser } from "../resy/user_pb";
import { file_resy_user } from "../resy/user_pb";
import type { TockPatron } from "../tock/patron_pb";
import { file_tock_patron } from "../tock/patron_pb";
import type { GdusUser } from "./gdus_user_pb";
import { file_user_gdus_user } from "./gdus_user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/user_administration.proto.
 */
export const file_user_user_administration: GenFile = /*@__PURE__*/
  fileDesc("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", [file_resy_user, file_tock_patron, file_user_gdus_user]);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ActivateUsersRequest
 */
export type ActivateUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.ActivateUsersRequest"> & {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ActivateUsersRequest.
 * Use `create(ActivateUsersRequestSchema)` to create a new message.
 */
export const ActivateUsersRequestSchema: GenMessage<ActivateUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 0);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ActivateUsersResponse
 */
export type ActivateUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.ActivateUsersResponse"> & {
  /**
   * @generated from field: repeated string not_found_uuids = 1;
   */
  notFoundUuids: string[];

  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.ActivateUserResult results = 2;
   */
  results: ActivateUserResult[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ActivateUsersResponse.
 * Use `create(ActivateUsersResponseSchema)` to create a new message.
 */
export const ActivateUsersResponseSchema: GenMessage<ActivateUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 1);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ActivateUserResult
 */
export type ActivateUserResult = Message<"com.americanexpress.dining.user.admin.proto.ActivateUserResult"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.ActivateUserStatus status = 2;
   */
  status: ActivateUserStatus;

  /**
   * populated when status = FAILED (failing system(s) + raw message)
   *
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ActivateUserResult.
 * Use `create(ActivateUserResultSchema)` to create a new message.
 */
export const ActivateUserResultSchema: GenMessage<ActivateUserResult> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 2);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest
 */
export type DeactivateUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest"> & {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * Structured reason token. Mapped at the Resy boundary to
   * user_appuserdeactivationreason.deactivation_reason via DeactivationReasons.toResyWireValue.
   *
   * @generated from field: com.americanexpress.dining.user.admin.proto.DeactivationReason reason_code = 3;
   */
  reasonCode: DeactivationReason;

  /**
   * Operator toggle for whether the affected user is notified. When true, a "deactivated"
   * confirmation is sent once the GDUS lockout succeeds. Unset/false (the conservative default)
   * suppresses all notifications. Notifications are best-effort and never block or fail the
   * deactivation.
   *
   * @generated from field: optional bool send_notification = 4;
   */
  sendNotification?: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest.
 * Use `create(DeactivateUsersRequestSchema)` to create a new message.
 */
export const DeactivateUsersRequestSchema: GenMessage<DeactivateUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 3);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse
 */
export type DeactivateUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse"> & {
  /**
   * UUIDs from the request that did not match any GDUS user — skipped without error.
   *
   * @generated from field: repeated string not_found_uuids = 1;
   */
  notFoundUuids: string[];

  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.DeactivateUserResult results = 2;
   */
  results: DeactivateUserResult[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse.
 * Use `create(DeactivateUsersResponseSchema)` to create a new message.
 */
export const DeactivateUsersResponseSchema: GenMessage<DeactivateUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 4);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeactivateUserResult
 */
export type DeactivateUserResult = Message<"com.americanexpress.dining.user.admin.proto.DeactivateUserResult"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.DeactivateUserStatus status = 2;
   */
  status: DeactivateUserStatus;

  /**
   * populated when status = FAILED (failing system(s) + raw message)
   *
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeactivateUserResult.
 * Use `create(DeactivateUserResultSchema)` to create a new message.
 */
export const DeactivateUserResultSchema: GenMessage<DeactivateUserResult> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 5);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: repeated string concierge_group_names = 2;
   */
  conciergeGroupNames: string[];

  /**
   * @generated from field: optional string email_address = 3;
   */
  emailAddress?: string;

  /**
   * @generated from field: string phone_number = 4;
   */
  phoneNumber: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 6);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserResponse"> & {
  /**
   * @generated from oneof com.americanexpress.dining.user.admin.proto.UpdateUserResponse.response
   */
  response: {
    /**
     * @generated from field: com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse success_response = 1;
     */
    value: UpdateUserSuccessResponse;
    case: "successResponse";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse error_response = 2;
     */
    value: UpdateUserErrorResponse;
    case: "errorResponse";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 7);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse
 */
export type UpdateUserSuccessResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse.
 * Use `create(UpdateUserSuccessResponseSchema)` to create a new message.
 */
export const UpdateUserSuccessResponseSchema: GenMessage<UpdateUserSuccessResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 8);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserError
 */
export type UpdateUserError = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserError"> & {
  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponseReason reason = 1;
   */
  reason: UpdateUserErrorResponseReason;

  /**
   * Pass-through detail for failures that cannot be enumerated (Resy/Tock validation text). Empty
   * whenever reason is set to a known (non-UNSPECIFIED) value.
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserError.
 * Use `create(UpdateUserErrorSchema)` to create a new message.
 */
export const UpdateUserErrorSchema: GenMessage<UpdateUserError> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 9);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse
 */
export type UpdateUserErrorResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.UpdateUserError errors = 2;
   */
  errors: UpdateUserError[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse.
 * Use `create(UpdateUserErrorResponseSchema)` to create a new message.
 */
export const UpdateUserErrorResponseSchema: GenMessage<UpdateUserErrorResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 10);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UserSearchRequest
 */
export type UserSearchRequest = Message<"com.americanexpress.dining.user.admin.proto.UserSearchRequest"> & {
  /**
   * @generated from oneof com.americanexpress.dining.user.admin.proto.UserSearchRequest.search_type
   */
  searchType: {
    /**
     * @generated from field: string gdus_uuid = 1;
     */
    value: string;
    case: "gdusUuid";
  } | {
    /**
     * @generated from field: string email_address = 2;
     */
    value: string;
    case: "emailAddress";
  } | {
    /**
     * @generated from field: string phone_number = 3;
     */
    value: string;
    case: "phoneNumber";
  } | {
    /**
     * Tried against both Resy and Tock numeric IDs; may return up to two users.
     *
     * @generated from field: uint64 numeric_user_id = 4;
     */
    value: bigint;
    case: "numericUserId";
  } | {
    /**
     * wildcard name/email search
     *
     * @generated from field: string text = 5;
     */
    value: string;
    case: "text";
  } | { case: undefined; value?: undefined };

  /**
   * 0-indexed page number, defaults to 0
   *
   * @generated from field: optional int32 page = 6;
   */
  page?: number;

  /**
   * results per page, defaults to and capped at 25
   *
   * @generated from field: optional int32 page_size = 7;
   */
  pageSize?: number;

  /**
   * When false (default), Resy and Tock profile enrichment is skipped; only GDUS identity fields
   * are returned. Set to true for detail views where the full profile is needed.
   *
   * @generated from field: optional bool include_profiles = 8;
   */
  includeProfiles?: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UserSearchRequest.
 * Use `create(UserSearchRequestSchema)` to create a new message.
 */
export const UserSearchRequestSchema: GenMessage<UserSearchRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 11);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.User
 */
export type User = Message<"com.americanexpress.dining.user.admin.proto.User"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.user.proto.GdusUser gdus_user = 1;
   */
  gdusUser?: GdusUser;

  /**
   * @generated from field: optional com.americanexpress.dining.resy.proto.ResyUser resy_user = 2;
   */
  resyUser?: ResyUser;

  /**
   * @generated from field: optional com.americanexpress.dining.tock.proto.TockPatron tock_patron = 3;
   */
  tockPatron?: TockPatron;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 12);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UserSearchResponse
 */
export type UserSearchResponse = Message<"com.americanexpress.dining.user.admin.proto.UserSearchResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UserSearchResponse.
 * Use `create(UserSearchResponseSchema)` to create a new message.
 */
export const UserSearchResponseSchema: GenMessage<UserSearchResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 13);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.SyncUserRequest
 */
export type SyncUserRequest = Message<"com.americanexpress.dining.user.admin.proto.SyncUserRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.SyncUserRequest.
 * Use `create(SyncUserRequestSchema)` to create a new message.
 */
export const SyncUserRequestSchema: GenMessage<SyncUserRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 14);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.SyncUserResponse
 */
export type SyncUserResponse = Message<"com.americanexpress.dining.user.admin.proto.SyncUserResponse"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.SyncUserResponse.
 * Use `create(SyncUserResponseSchema)` to create a new message.
 */
export const SyncUserResponseSchema: GenMessage<SyncUserResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 15);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityRequest
 */
export type RetryGdaEligibilityRequest = Message<"com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityRequest.
 * Use `create(RetryGdaEligibilityRequestSchema)` to create a new message.
 */
export const RetryGdaEligibilityRequestSchema: GenMessage<RetryGdaEligibilityRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 16);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityResponse
 */
export type RetryGdaEligibilityResponse = Message<"com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityResponse"> & {
  /**
   * True when the user has no eligible American Express card on file in Resy, so there was nothing
   * to recompute.
   *
   * @generated from field: bool no_amex_card = 1;
   */
  noAmexCard: boolean;

  /**
   * Number of previously failed/quarantined eligibility checks that were re-queued.
   *
   * @generated from field: int32 retried_count = 2;
   */
  retriedCount: number;

  /**
   * Number of American Express cards currently registered in the user's Resy wallet.
   *
   * @generated from field: int32 amex_cards_registered = 3;
   */
  amexCardsRegistered: number;

  /**
   * Human-readable summary of the recompute result, mirroring BlueAdmin.
   *
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.RetryGdaEligibilityResponse.
 * Use `create(RetryGdaEligibilityResponseSchema)` to create a new message.
 */
export const RetryGdaEligibilityResponseSchema: GenMessage<RetryGdaEligibilityResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 17);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeleteUsersRequest
 */
export type DeleteUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.DeleteUsersRequest"> & {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeleteUsersRequest.
 * Use `create(DeleteUsersRequestSchema)` to create a new message.
 */
export const DeleteUsersRequestSchema: GenMessage<DeleteUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 18);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeleteUsersResponse
 */
export type DeleteUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.DeleteUsersResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.DeleteUserResult results = 1;
   */
  results: DeleteUserResult[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeleteUsersResponse.
 * Use `create(DeleteUsersResponseSchema)` to create a new message.
 */
export const DeleteUsersResponseSchema: GenMessage<DeleteUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 19);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeleteUserResult
 */
export type DeleteUserResult = Message<"com.americanexpress.dining.user.admin.proto.DeleteUserResult"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.DeleteUserStatus status = 2;
   */
  status: DeleteUserStatus;

  /**
   * populated when status = FAILED (raw workflow message)
   *
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeleteUserResult.
 * Use `create(DeleteUserResultSchema)` to create a new message.
 */
export const DeleteUserResultSchema: GenMessage<DeleteUserResult> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 20);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.AddSuspectedBotRequest
 */
export type AddSuspectedBotRequest = Message<"com.americanexpress.dining.user.admin.proto.AddSuspectedBotRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.AddSuspectedBotRequest.
 * Use `create(AddSuspectedBotRequestSchema)` to create a new message.
 */
export const AddSuspectedBotRequestSchema: GenMessage<AddSuspectedBotRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 21);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.AddSuspectedBotResponse
 */
export type AddSuspectedBotResponse = Message<"com.americanexpress.dining.user.admin.proto.AddSuspectedBotResponse"> & {
  /**
   * True when a new suspected-bot row was inserted; false when the user was already flagged (the
   * insert is idempotent, so a repeat request is a no-op).
   *
   * @generated from field: bool created = 1;
   */
  created: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.AddSuspectedBotResponse.
 * Use `create(AddSuspectedBotResponseSchema)` to create a new message.
 */
export const AddSuspectedBotResponseSchema: GenMessage<AddSuspectedBotResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 22);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.StartBulkUserActionRequest
 */
export type StartBulkUserActionRequest = Message<"com.americanexpress.dining.user.admin.proto.StartBulkUserActionRequest"> & {
  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.BulkUserAction action = 1;
   */
  action: BulkUserAction;

  /**
   * @generated from field: repeated string uuids = 2;
   */
  uuids: string[];

  /**
   * Operator free-text note (maps to Resy deactivation_description), like DeactivateUsersRequest.
   *
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.DeactivationReason reason_code = 4;
   */
  reasonCode: DeactivationReason;

  /**
   * When true, each affected user is sent a confirmation once locked out. Best-effort. Unset/false
   * suppresses all notifications.
   *
   * @generated from field: optional bool send_notification = 5;
   */
  sendNotification?: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.StartBulkUserActionRequest.
 * Use `create(StartBulkUserActionRequestSchema)` to create a new message.
 */
export const StartBulkUserActionRequestSchema: GenMessage<StartBulkUserActionRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 23);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.StartBulkUserActionResponse
 */
export type StartBulkUserActionResponse = Message<"com.americanexpress.dining.user.admin.proto.StartBulkUserActionResponse"> & {
  /**
   * Deterministic id of the bulk workflow (bulk-user-deactivate-<adminId>)
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * True when a bulk run for this operator was already RUNNING, so this request attached to it
   * instead of starting a new one — the users/params in this request were NOT applied.
   *
   * @generated from field: bool attached_to_existing_run = 2;
   */
  attachedToExistingRun: boolean;

  /**
   * UUIDs from the request that did not match any GDUS user — skipped without error.
   *
   * @generated from field: repeated string not_found_uuids = 3;
   */
  notFoundUuids: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.StartBulkUserActionResponse.
 * Use `create(StartBulkUserActionResponseSchema)` to create a new message.
 */
export const StartBulkUserActionResponseSchema: GenMessage<StartBulkUserActionResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 24);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.GetBulkUserActionStatusRequest
 */
export type GetBulkUserActionStatusRequest = Message<"com.americanexpress.dining.user.admin.proto.GetBulkUserActionStatusRequest"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.GetBulkUserActionStatusRequest.
 * Use `create(GetBulkUserActionStatusRequestSchema)` to create a new message.
 */
export const GetBulkUserActionStatusRequestSchema: GenMessage<GetBulkUserActionStatusRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 25);

/**
 * Progress of a bulk action.
 *
 * @generated from message com.americanexpress.dining.user.admin.proto.BulkUserActionStatus
 */
export type BulkUserActionStatus = Message<"com.americanexpress.dining.user.admin.proto.BulkUserActionStatus"> & {
  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.BulkActionPhase phase = 1;
   */
  phase: BulkActionPhase;

  /**
   * @generated from field: int32 num_total = 2;
   */
  numTotal: number;

  /**
   * @generated from field: int32 num_processed = 3;
   */
  numProcessed: number;

  /**
   * @generated from field: int32 num_success = 4;
   */
  numSuccess: number;

  /**
   * @generated from field: int32 num_failed = 5;
   */
  numFailed: number;

  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.BulkUserActionItemResult results = 6;
   */
  results: BulkUserActionItemResult[];

  /**
   * @generated from field: int32 num_truncated_results = 7;
   */
  numTruncatedResults: number;

  /**
   * @generated from field: bool done = 8;
   */
  done: boolean;

  /**
   * @generated from field: bool attached_to_existing_run = 9;
   */
  attachedToExistingRun: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.BulkUserActionStatus.
 * Use `create(BulkUserActionStatusSchema)` to create a new message.
 */
export const BulkUserActionStatusSchema: GenMessage<BulkUserActionStatus> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 26);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.BulkUserActionItemResult
 */
export type BulkUserActionItemResult = Message<"com.americanexpress.dining.user.admin.proto.BulkUserActionItemResult"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: com.americanexpress.dining.user.admin.proto.BulkUserActionItemStatus status = 2;
   */
  status: BulkUserActionItemStatus;

  /**
   * populated when status = FAILED (failing system(s) + message)
   *
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.BulkUserActionItemResult.
 * Use `create(BulkUserActionItemResultSchema)` to create a new message.
 */
export const BulkUserActionItemResultSchema: GenMessage<BulkUserActionItemResult> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 27);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.CancelBulkUserActionRequest
 */
export type CancelBulkUserActionRequest = Message<"com.americanexpress.dining.user.admin.proto.CancelBulkUserActionRequest"> & {
  /**
   * UUIDs to skip when the deactivation phase reaches them (ignored when cancel_all is true).
   *
   * @generated from field: repeated string exclude_uuids = 1;
   */
  excludeUuids: string[];

  /**
   * Abort the entire bulk run.
   *
   * @generated from field: bool cancel_all = 2;
   */
  cancelAll: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.CancelBulkUserActionRequest.
 * Use `create(CancelBulkUserActionRequestSchema)` to create a new message.
 */
export const CancelBulkUserActionRequestSchema: GenMessage<CancelBulkUserActionRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 28);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.CancelBulkUserActionResponse
 */
export type CancelBulkUserActionResponse = Message<"com.americanexpress.dining.user.admin.proto.CancelBulkUserActionResponse"> & {
  /**
   * True when the whole run was cancelled (cancel_all); false for a partial exclude.
   *
   * @generated from field: bool cancelled = 1;
   */
  cancelled: boolean;

  /**
   * Number of uuids added to the exclude set.
   *
   * @generated from field: int32 num_excluded = 2;
   */
  numExcluded: number;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.CancelBulkUserActionResponse.
 * Use `create(CancelBulkUserActionResponseSchema)` to create a new message.
 */
export const CancelBulkUserActionResponseSchema: GenMessage<CancelBulkUserActionResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 29);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ResolveUsersRequest
 */
export type ResolveUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.ResolveUsersRequest"> & {
  /**
   * Free-text identifiers pasted by the operator: uuid, email, phone (+E.164), or numeric id.
   *
   * @generated from field: repeated string identifiers = 1;
   */
  identifiers: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ResolveUsersRequest.
 * Use `create(ResolveUsersRequestSchema)` to create a new message.
 */
export const ResolveUsersRequestSchema: GenMessage<ResolveUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 30);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ResolveUsersResponse
 */
export type ResolveUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.ResolveUsersResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.User resolved = 1;
   */
  resolved: User[];

  /**
   * Identifiers that matched no known user.
   *
   * @generated from field: repeated string unresolved = 2;
   */
  unresolved: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ResolveUsersResponse.
 * Use `create(ResolveUsersResponseSchema)` to create a new message.
 */
export const ResolveUsersResponseSchema: GenMessage<ResolveUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 31);

/**
 * @generated from enum com.americanexpress.dining.user.admin.proto.ActivateUserStatus
 */
export enum ActivateUserStatus {
  /**
   * @generated from enum value: ACTIVATE_USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVATE_USER_STATUS_REACTIVATED = 1;
   */
  REACTIVATED = 1,

  /**
   * @generated from enum value: ACTIVATE_USER_STATUS_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * @generated from enum value: ACTIVATE_USER_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.ActivateUserStatus.
 */
export const ActivateUserStatusSchema: GenEnum<ActivateUserStatus> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 0);

/**
 * Structured deactivation vocabulary shared with Resy. The values here map to Resy's stored
 * `user_appuserdeactivationreason.deactivation_reason` tokens via DeactivationReasons.toResyWireValue
 * (an explicit mapper — Resy's stored values are stylistically inconsistent, so name().toLowerCase()
 * is wrong). The bot signals (see DeactivationReasons.isBotSignal) additionally drive the
 * reservation_suspectedbotuser upsert on the Resy side.
 *
 * @generated from enum com.americanexpress.dining.user.admin.proto.DeactivationReason
 */
export enum DeactivationReason {
  /**
   * @generated from enum value: DEACTIVATION_REASON_UNSPECIFIED = 0;
   */
  DEACTIVATION_REASON_UNSPECIFIED = 0,

  /**
   * bot signal
   *
   * @generated from enum value: BOT = 1;
   */
  BOT = 1,

  /**
   * @generated from enum value: USER_REQUEST = 2;
   */
  USER_REQUEST = 2,

  /**
   * @generated from enum value: OTHER = 3;
   */
  OTHER = 3,

  /**
   * @generated from enum value: UNKNOWN = 4;
   */
  UNKNOWN = 4,

  /**
   * bot signal
   *
   * @generated from enum value: SHARED_CREDIT_CARD = 5;
   */
  SHARED_CREDIT_CARD = 5,

  /**
   * bot signal
   *
   * @generated from enum value: IP_SWEEP = 6;
   */
  IP_SWEEP = 6,

  /**
   * bot signal
   *
   * @generated from enum value: PREVIOUSLY_DEACTIVATED_CREDIT_CARD = 7;
   */
  PREVIOUSLY_DEACTIVATED_CREDIT_CARD = 7,

  /**
   * bot signal
   *
   * @generated from enum value: RATE_LIMIT = 8;
   */
  RATE_LIMIT = 8,

  /**
   * bot signal
   *
   * @generated from enum value: MACHINE_LEARNING_MODEL = 9;
   */
  MACHINE_LEARNING_MODEL = 9,

  /**
   * bot signal
   *
   * @generated from enum value: MANUAL_PARTNER_FLAG = 10;
   */
  MANUAL_PARTNER_FLAG = 10,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.DeactivationReason.
 */
export const DeactivationReasonSchema: GenEnum<DeactivationReason> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 1);

/**
 * @generated from enum com.americanexpress.dining.user.admin.proto.DeactivateUserStatus
 */
export enum DeactivateUserStatus {
  /**
   * @generated from enum value: DEACTIVATE_USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEACTIVATE_USER_STATUS_DEACTIVATED = 1;
   */
  DEACTIVATED = 1,

  /**
   * @generated from enum value: DEACTIVATE_USER_STATUS_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * @generated from enum value: DEACTIVATE_USER_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.DeactivateUserStatus.
 */
export const DeactivateUserStatusSchema: GenEnum<DeactivateUserStatus> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 2);

/**
 * @generated from enum com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponseReason
 */
export enum UpdateUserErrorResponseReason {
  /**
   * @generated from enum value: UPDATE_USER_ERROR_RESPONSE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPDATE_USER_ERROR_RESPONSE_REASON_EMAIL_ALREADY_IN_USE = 1;
   */
  EMAIL_ALREADY_IN_USE = 1,

  /**
   * @generated from enum value: UPDATE_USER_ERROR_RESPONSE_REASON_PHONE_ALREADY_IN_USE = 2;
   */
  PHONE_ALREADY_IN_USE = 2,

  /**
   * @generated from enum value: UPDATE_USER_ERROR_RESPONSE_REASON_SERVICE_UNAVAILABLE = 3;
   */
  SERVICE_UNAVAILABLE = 3,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponseReason.
 */
export const UpdateUserErrorResponseReasonSchema: GenEnum<UpdateUserErrorResponseReason> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 3);

/**
 * @generated from enum com.americanexpress.dining.user.admin.proto.DeleteUserStatus
 */
export enum DeleteUserStatus {
  /**
   * @generated from enum value: DELETE_USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELETE_USER_STATUS_DELETED = 1;
   */
  DELETED = 1,

  /**
   * @generated from enum value: DELETE_USER_STATUS_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * @generated from enum value: DELETE_USER_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.DeleteUserStatus.
 */
export const DeleteUserStatusSchema: GenEnum<DeleteUserStatus> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 4);

/**
 * The kind of bulk action to run. Extensible; only DEACTIVATE is handled in this release.
 *
 * @generated from enum com.americanexpress.dining.user.admin.proto.BulkUserAction
 */
export enum BulkUserAction {
  /**
   * @generated from enum value: BULK_USER_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BULK_USER_ACTION_DEACTIVATE = 1;
   */
  DEACTIVATE = 1,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.BulkUserAction.
 */
export const BulkUserActionSchema: GenEnum<BulkUserAction> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 5);

/**
 * Coarse phase of a bulk action, driving the FE progress display.
 *
 * @generated from enum com.americanexpress.dining.user.admin.proto.BulkActionPhase
 */
export enum BulkActionPhase {
  /**
   * @generated from enum value: BULK_ACTION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BULK_ACTION_PHASE_DEACTIVATING = 1;
   */
  DEACTIVATING = 1,

  /**
   * @generated from enum value: BULK_ACTION_PHASE_DONE = 2;
   */
  DONE = 2,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.BulkActionPhase.
 */
export const BulkActionPhaseSchema: GenEnum<BulkActionPhase> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 6);

/**
 * @generated from enum com.americanexpress.dining.user.admin.proto.BulkUserActionItemStatus
 */
export enum BulkUserActionItemStatus {
  /**
   * @generated from enum value: BULK_USER_ACTION_ITEM_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BULK_USER_ACTION_ITEM_STATUS_SUCCEEDED = 1;
   */
  SUCCEEDED = 1,

  /**
   * @generated from enum value: BULK_USER_ACTION_ITEM_STATUS_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: BULK_USER_ACTION_ITEM_STATUS_SKIPPED = 3;
   */
  SKIPPED = 3,
}

/**
 * Describes the enum com.americanexpress.dining.user.admin.proto.BulkUserActionItemStatus.
 */
export const BulkUserActionItemStatusSchema: GenEnum<BulkUserActionItemStatus> = /*@__PURE__*/
  enumDesc(file_user_user_administration, 7);

/**
 * @generated from service com.americanexpress.dining.user.admin.proto.UserAdministrationService
 */
export const UserAdministrationService: GenService<{
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.ActivateUsers
   */
  activateUsers: {
    methodKind: "unary";
    input: typeof ActivateUsersRequestSchema;
    output: typeof ActivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.DeactivateUsers
   */
  deactivateUsers: {
    methodKind: "unary";
    input: typeof DeactivateUsersRequestSchema;
    output: typeof DeactivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.UserSearch
   */
  userSearch: {
    methodKind: "unary";
    input: typeof UserSearchRequestSchema;
    output: typeof UserSearchResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.SyncUser
   */
  syncUser: {
    methodKind: "unary";
    input: typeof SyncUserRequestSchema;
    output: typeof SyncUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.RetryGdaEligibility
   */
  retryGdaEligibility: {
    methodKind: "unary";
    input: typeof RetryGdaEligibilityRequestSchema;
    output: typeof RetryGdaEligibilityResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.DeleteUsers
   */
  deleteUsers: {
    methodKind: "unary";
    input: typeof DeleteUsersRequestSchema;
    output: typeof DeleteUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.AddSuspectedBot
   */
  addSuspectedBot: {
    methodKind: "unary";
    input: typeof AddSuspectedBotRequestSchema;
    output: typeof AddSuspectedBotResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.StartBulkUserAction
   */
  startBulkUserAction: {
    methodKind: "unary";
    input: typeof StartBulkUserActionRequestSchema;
    output: typeof StartBulkUserActionResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.GetBulkUserActionStatus
   */
  getBulkUserActionStatus: {
    methodKind: "unary";
    input: typeof GetBulkUserActionStatusRequestSchema;
    output: typeof BulkUserActionStatusSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.CancelBulkUserAction
   */
  cancelBulkUserAction: {
    methodKind: "unary";
    input: typeof CancelBulkUserActionRequestSchema;
    output: typeof CancelBulkUserActionResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.ResolveUsers
   */
  resolveUsers: {
    methodKind: "unary";
    input: typeof ResolveUsersRequestSchema;
    output: typeof ResolveUsersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_user_administration, 0);

